/**
 * The route table — one source of truth for the router AND the navigation.
 *
 * Assembled from one file per domain. It used to be a single list, which grew
 * past the point where you could find anything in it; splitting by domain means
 * adding a screen touches a short file next to its siblings.
 *
 * ORDER IS NOT SIGNIFICANT here: the router matches by path, and the navigation
 * sorts by `nav.order`. So the concatenation below is alphabetical by domain,
 * not a priority list.
 */
import { ACADEMICS_ROUTES } from "./academics";
import { ADMIN_ROUTES } from "./admin";
import { CORE_ROUTES } from "./core";
import { FINANCE_ROUTES } from "./finance";
import { PEOPLE_ROUTES } from "./people";
import type { AppRoute } from "./types";

export type { AppRoute };

export const ROUTES: AppRoute[] = [
  ...CORE_ROUTES,
  ...ACADEMICS_ROUTES,
  ...FINANCE_ROUTES,
  ...PEOPLE_ROUTES,
  ...ADMIN_ROUTES,
];
